import { useCallback } from 'react'
import { RepairOrder } from '~/shared/api'
import { snackbarEnqueued } from '~/shared/lib/notifications'
import { Filter } from '~/shared/ui/AsyncGrid'
import { useFiltersQueryParams } from '~/shared/ui/AsyncGrid/Filters'
import { FileExportBlob } from '~/shared/ui/FileExport'

type RepairOrderExportProps = { filters: Filter[] }

const FILTER_KEY_MAP: Record<string, string> = {
  car: 'filter[car][id]',
  subdivision: 'filter[subdivision][id]',
  user: 'filter[user][id]',
  repairTypes: 'filter[repairTypes][id]',
  counterparty: 'filter[counterparty][id]',
}

export const RepairOrderExport = ({ filters }: RepairOrderExportProps) => {
  const [filtersQueryParams] = useFiltersQueryParams(filters)

  const queryFilters = Object.fromEntries(
    Object.entries(filtersQueryParams)
      .map(([key, value]) => {
        const apiKey = FILTER_KEY_MAP[key] ?? `filter[${key}]`
        return [apiKey, (value as { id?: string })?.id ?? value]
      })
      .filter(([, value]) => Boolean(value)),
  )

  const queryFiltersKey = JSON.stringify(queryFilters)

  const handleExportFn = useCallback((): Promise<Blob> | void => {
    if (!filtersQueryParams.createdAtGte || !filtersQueryParams.createdAtLte) {
      snackbarEnqueued({
        messageI18n: 'alert.set date filter',
        variant: 'error',
      })
      return
    }

    return RepairOrder.exportExcel(
      new URLSearchParams(queryFilters as Record<string, string>).toString(),
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    filtersQueryParams.createdAtGte,
    filtersQueryParams.createdAtLte,
    queryFiltersKey,
  ])

  return <FileExportBlob titleI18n='button.export excel' fn={handleExportFn} />
}
